module.exports = __webpack_public_path__ + "img/soccer.ed39bf2f.svg";